// removed by extract-text-webpack-plugin
module.exports = {"Loader":"_1DDwYTkbvNoVwBDs8ZptVg","load2":"_1N7mgFPOaqyEMO5kgrH5tH","Grey":"_3sC5pRwkZwL-bbOs4H06nk","White":"-P_wFznvbJl2KlnqLUJT8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/Spinner.css
// module id = 260
// module chunks = 0